import React, { useMemo } from 'react';
import CustomToolbar from './Toolbar'; // Import the generic toolbar
import { Layer } from '../../types/layer'; // Assuming you have this type

interface LayersToolbarProps {
  layers: Layer[],
  labelSide?: "left" | "right" | "top"
}

const LayersToolbar: React.FC<LayersToolbarProps> = ({ layers, labelSide="left" }) => {
  const toolbarButtons = useMemo(() =>
    layers?.map((layer) => layer.toolbarButton).filter(Boolean),
    [layers]
  );

  return (
    <CustomToolbar direction="column">
      {toolbarButtons.map((button, index) => 
        React.cloneElement(button, { key: index, labelSide })
      )}
    </CustomToolbar>
  );
};

export default LayersToolbar;